import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils";

export interface ReferenceRangeProps extends React.ComponentProps<"p"> {
  range: string;
  unit: string;
  variant?: "full" | "short";
}

export const ReferenceRange = ({ range, unit, variant = "full", className, ...props }: ReferenceRangeProps) => {
  const { t } = useTranslation("ui");

  return (
    <p data-slot="reference-range" className={cn("text-xs text-gray-400 dark:text-gray-500", className)} {...props}>
      {variant === "short"
        ? t("Ref: {{range}} {{unit}}", { range, unit })
        : t("Reference range {{range}} {{unit}}", { range, unit })}
    </p>
  );
};
